import { ImportPayloadRow, ResolvedRow } from "./types";

/**
 * Convierte las filas resueltas en el payload que espera la lambda de importacion.
 *
 * `relationAttributes` son atributos que el formulario carga para mostrar (relaciones), no
 * columnas del modelo: no viajan al backend.
 */
export const buildImportPayload = <TData extends object>(
    rows: Array<ResolvedRow<TData>>,
    relationAttributes: Set<string>,
    buildMeta?: (row: ResolvedRow<TData>) => Record<string, unknown> | undefined
): ImportPayloadRow[] =>
    rows.map((row) => {
        const meta = row.action === "skip" ? undefined : buildMeta?.(row);

        return {
            action: row.action,
            id: row.action === "update" ? row.existingId : undefined,
            data: toPlainData(row.data, relationAttributes),
            ...(meta ? { meta } : {}),
        };
    });

const toPlainData = <TData extends object>(
    data: TData,
    relationAttributes: Set<string>
): Record<string, unknown> =>
    Object.entries(data).reduce<Record<string, unknown>>((plain, [key, value]) => {
        if (relationAttributes.has(key)) return plain;
        if (value === undefined || value === null) return plain;
        return { ...plain, [key]: value };
    }, {});
